// actions
export const GET_POPULAR_BUILDS = 'GET_POPULAR_BUILDS'

// mutations
export const GET_POPULAR_BUILDS_PENDING = 'GET_POPULAR_BUILDS_PENDING'
export const GET_POPULAR_BUILDS_SUCCESS = 'GET_POPULAR_BUILDS_SUCCESS'
export const GET_POPULAR_BUILDS_FAILURE = 'GET_POPULAR_BUILDS_FAILURE'
